import { render, staticRenderFns } from "./DesktopTab.vue?vue&type=template&id=408ce1ef"
import script from "./DesktopTab.vue?vue&type=script&lang=js"
export * from "./DesktopTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports